import { GET_STUDENT_PERSONAL_ACCESS } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponseObject } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

interface IPersonalAccess {
  id: number;
  person_id: string;
  creationDate: Date;
  editedDate: Date;
  isActive: boolean;
}

export type StudentPersonalAccessState = ICommonResponseObject<IPersonalAccess | null>;

const initialState: StudentPersonalAccessState = {
  content: null,
  loading: false,
};
const generic = genericReducers<StudentPersonalAccessState>();
const studentMetaSkills: IReducers<StudentPersonalAccessState> = {
  [GET_STUDENT_PERSONAL_ACCESS[REQUEST]]: generic.get.request,
  [GET_STUDENT_PERSONAL_ACCESS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_PERSONAL_ACCESS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_PERSONAL_ACCESS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentMetaSkills);
